module.exports = "/_next/static/images/31-1-fae161513e8fd081cace05e2af0fd420.jpg";